import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import {
  FiMonitor, FiSmartphone, FiCode, FiServer,
  FiGlobe, FiCloud, FiCpu, FiShield
} from 'react-icons/fi';
import './Services.css';

const services = [
  { key: 'itConsultation', icon: FiMonitor, color: '#5cb0dd', gradient: 'linear-gradient(135deg, #5cb0dd, #3a95c9)' },
  { key: 'androidDev', icon: FiSmartphone, color: '#10b981', gradient: 'linear-gradient(135deg, #10b981, #059669)' },
  { key: 'iosDev', icon: FiShield, color: '#6366f1', gradient: 'linear-gradient(135deg, #6366f1, #4f46e5)' },
  { key: 'webDev', icon: FiCode, color: '#f59e0b', gradient: 'linear-gradient(135deg, #f59e0b, #d97706)' },
  { key: 'linux', icon: FiServer, color: '#ef4444', gradient: 'linear-gradient(135deg, #ef4444, #dc2626)' },
  { key: 'domain', icon: FiGlobe, color: '#8b5cf6', gradient: 'linear-gradient(135deg, #8b5cf6, #7c3aed)' },
  { key: 'hosting', icon: FiCloud, color: '#ec4899', gradient: 'linear-gradient(135deg, #ec4899, #db2777)' },
  { key: 'ai', icon: FiCpu, color: '#06b6d4', gradient: 'linear-gradient(135deg, #06b6d4, #0891b2)' },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.1 }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
};

const Services = () => {
  const { t } = useTranslation();

  return (
    <section id="services" className="section services-section">
      <div className="services-bg-accent"></div>
      <div className="container text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="section-tag">{t('services.sectionTag')}</span>
          <h2 className="section-title">{t('services.title')}</h2>
          <p className="section-subtitle">{t('services.subtitle')}</p>
        </motion.div>

        <motion.div
          className="services-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {services.map((service) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.key}
                className="service-card"
                variants={cardVariants}
                whileHover={{ y: -10, transition: { duration: 0.3 } }}
              >
                <div className="service-icon-wrapper">
                  <div className="service-icon" style={{ background: service.gradient }}>
                    <Icon size={26} />
                  </div>
                  <div className="service-icon-glow" style={{ background: service.color }}></div>
                </div>
                <h3 className="service-title">{t(`services.${service.key}.title`)}</h3>
                <p className="service-desc">{t(`services.${service.key}.desc`)}</p>
                <div className="service-line" style={{ background: service.gradient }}></div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default Services;
